import * as React from 'react'

import * as styles from './GoToButton.module.less'

export interface GoToButtonProps {
    content?: React.ReactNode
    to: 'top' | 'bottom'
    visible: boolean
}

export const GoToButton: React.FC<GoToButtonProps> = props => {
    const { content, to, visible } = props

    return (
        <div
            className={
                to === 'top'
                    ? styles.goToTopButton
                    : styles.goToBottomButton
            }
            style={{ visibility: visible ? 'visible' : 'hidden' }}
        >
            {content}
        </div>
    )
}
